import { useState, useEffect } from "react";
import Table from "../Table/Table";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { Bounce, toast } from "react-toastify";
import "./tipologiaTitoli.css";
import PopUp from "../PopUp";

const TipologiaTitoli = () => {
  const [loading, setLoading] = useState(false);
  const [tipologiaTitoli, setTipologiaTitoli] = useState([]);
  const navigate = useNavigate();
  const [perPage] = useState(20);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showPopUp, setShowPopUp] = useState(false);
  const [selectedTipologiaId, setSelectedTipologiaId] = useState(null);
  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "ADMIN") {
      alert(
        "Accedi come amministratore per visualizzare le tipologie di titoli!"
      );

      navigate("/login");
    } else {
      fetchTipologiaTitoli();
    }
  }, [navigate]);

  const fetchTipologiaTitoli = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/tipologia-titoli`);
      if (response.status === 200) {
        setTipologiaTitoli(response.data);
        setTotalRows(response.data.length);
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRowClick = (tipologiaTitoli) => {
    navigate(`/tipologia-titolo/${tipologiaTitoli.idTipologiaTitolo}`, {
      state: { tipologiaTitoli },
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedTipologiaTitoli = tipologiaTitoli.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  const columns = [
    { field: "titoloTipologia", header: "Tipologia" },
    { field: "descrizioneTitolo", header: "Descrizione" },
    { field: "livelloTitoloDiStudio", header: "Livello Studio" },
    { field: "punteggioTitolo", header: "Punteggio" },
    {
      header: "Azioni",
      Cell: ({ row }) => (
        <button
          className="outside-delete-btn"
          onClick={(e) => {
            e.stopPropagation();
            setSelectedTipologiaId(row.original.idTipologiaTitolo);
            setShowPopUp(true);
          }}
        >
          <i className="fa-solid fa-trash"></i> Elimina
        </button>
      ),
    },
  ];

  const handleDelete = async () => {
    try {
      const response = await api.delete(
        `/tipologia-titoli/${selectedTipologiaId}`
      );
      if (response.status === 204) {
        toast.success("Tipologia titolo eliminata con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        fetchTipologiaTitoli();
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <PopUp
        open={showPopUp}
        setOpen={setShowPopUp}
        header="Conferma Eliminazione"
        content="Sei sicuro di voler rimuovere questa tipologia titoli?"
        deleteFunction={handleDelete}
      />

      <div className="page-header">
        <div className="page-title">Tipologia Titolo</div>
        <div className="controls">
          <div className="add-btn">
            <button onClick={() => navigate("/aggiungi-tipologia-titolo")}>
              + Nuova tipologia
            </button>
          </div>
        </div>
      </div>

      <div className="page-content sedi">
        <Table
          columns={columns}
          data={paginatedTipologiaTitoli}
          onRowClick={handleRowClick}
          onPageChange={handlePageChange}
          totalRows={totalRows}
          perPage={perPage}
          currentPage={currentPage}
        />
      </div>
    </div>
  );
};

export default TipologiaTitoli;
